<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LW5Mxx/tc-custom/9781429935777.jpg?1737771306441" alt="This image is the cover for the book Eyes on the Goal, The 4 for 4 Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eyes on the Goal, The 4 for 4 Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Here is a story about how life, like sports, can be unpredictable, frustrating, and exhilarating. <i>Eyes on the Goal</i> by John Coy is part of the 4 for 4 series, an action-packed middle grade series for young readers about four boys from diverse backgrounds who deal with family, friendship, and school situations. <br/></b><br/>Just before they're due to start middle school, Diego, Gig, Jackson, and Isaac, four sports-loving friends, all attend the same weeklong soccer camp. Diego is an experienced soccer player, and Gig has a natural ability for the sport he never realized. But Jackson and Isaac are split  into another group of players—a group with younger, smaller kids. For the first time, both boys aren't the stars of their team. In fact, they can't seem to get a handle on soccer. At the same time, Jackson is having a hard time getting a handle on his mom's deepening relationship with her boyfriend, and her suggestion that they move in with him. And Gig is worried about his father's deployment to Afghanistan. <br/><br/>"Light, enjoyable reading for those downtimes between sports seasons." —<i>Booklist</i><br/><br/>"Coy has created a story of just the right length to keep his fans engaged. It is not necessary to have read <i>Top of the Order</i> to appreciate this one. Hints of fall football in middle school indicate that a third book is to follow." —<i>School Library Journal</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Coy
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Feiwel and Friends
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44eb4ee7